import NestedForm from "@stimulus-components/rails-nested-form/dist/stimulus-rails-nested-form.umd.js"

export default class extends NestedForm {
  add (event) {
    super.add(event)

    const allContentBlocks = this.element.querySelectorAll(".nested-form-wrapper")
    const currentContentBlockElement = allContentBlocks[allContentBlocks.length - 1]

    if (currentContentBlockElement !== undefined) {
      const positionInput = currentContentBlockElement.querySelector("input[name*='position']")
      if (positionInput) {
        positionInput.value = allContentBlocks.length
      }
    }
  }
}
